/** 主包已上传，但 parse-result 的 parse_status 为 failed */
export class PackageParseError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'PackageParseError'
  }
}
